var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23133 5.39686C8.12645 5.09945 7.93178 4.84195 7.67424 4.65995C7.41669 4.47795 7.10898 4.38043 6.79362 4.38086H5.61419C5.27838 4.38031 4.95424 4.50402 4.70419 4.72816C4.45414 4.9523 4.29585 5.26103 4.25981 5.5949C4.22377 5.92877 4.31253 6.26416 4.50899 6.53651C4.70544 6.80885 4.99571 6.99888 5.3239 7.07L7.11933 7.46315C7.4864 7.54369 7.81078 7.75697 8.03022 8.06204C8.24966 8.36711 8.3487 8.74249 8.30832 9.11611C8.26794 9.48973 8.09099 9.83527 7.81143 10.0864C7.53188 10.3376 7.16941 10.4766 6.79362 10.4769H5.77876C5.46334 10.4769 5.15568 10.3791 4.89818 10.1969C4.64068 10.0147 4.44603 9.75716 4.34105 9.45972",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28516 4.38085V2.85742",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28516 12V10.4766",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7151 0.571289H2.85798C2.25177 0.571289 1.67039 0.812105 1.24174 1.24076C0.813081 1.66941 0.572266 2.25079 0.572266 2.857V15.4284L3.42941 13.7141L6.28655 15.4284L9.14369 13.7141L12.0008 15.4284V2.28557C12.0008 1.83092 12.1814 1.39488 12.5029 1.07339C12.8244 0.751901 13.2605 0.571289 13.7151 0.571289ZM13.7151 0.571289C14.1698 0.571289 14.6058 0.751901 14.9273 1.07339C15.2488 1.39488 15.4294 1.83092 15.4294 2.28557V6.28558H12.0008",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodIcon);
export default __webpack_public_path__ + "static/media/payment-method-icon.f00961beba59d02351bc1f705e424b74.svg";
export { ForwardRef as ReactComponent };